const NotFound = () => <div style={{ padding: "2rem" }}>Page not found</div>;

export default NotFound;
